
    <!--
 * 竖版-兑换奖励
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_O87P194"  :class="[`normal`,`u_c_O87P194`]" ><div id="u_c_KU9E195"  v-html="compData.title" :class="[`${ compData.title ? 'text' : '' }`,`normal`,`u_c_KU9E195`]" ></div><div id="u_c_H5DI196"  v-html="compData.subTitle" :class="[`normal`,`u_c_H5DI196`]" ></div><div id="u_c_EYZL197"  :class="[`normal`,`u_c_EYZL197`]" ><span id="u_c_BN8H198"  :class="[`normal txt `,`u_c_BN8H198`]" >{{`${ langData.myLotteryTime }:`}}</span><span id="u_c_M7UT200"  :class="[`normal txt `,`u_c_M7UT200`]" >{{`${ pageData.lotteryTime }`}}</span><a id="u_c_F4HT202" href="javascript:;" :class="[`normal txt `,`u_c_F4HT202`]" @click="u_c_F4HT202_event_MAWI24($event)">{{`[${ langData.refresh }]`}}</a></div><div id="u_c_B0CK204"  :class="[`normal`,`u_c_B0CK204`]" ><div id="u_c_563O205"  v-show="compData.exchangeInfo.length > compData.count" :class="[`normal swiper-button-prev-btn btn-light rtl-trans`,`u_c_563O205`]" ></div><div id="u_c_9TY9206"  v-show="compData.exchangeInfo.length > compData.count" :class="[`normal swiper-button-next-btn btn-light `,`u_c_9TY9206`]" ></div><swiper id="u_c_GCF1207"  :navigation="({
    nextEl: '.swiper-button-next-btn',
    prevEl: '.swiper-button-prev-btn'
})" :modules="modules" :slides-per-view="1" :class="[`normal`,`u_c_GCF1207`]" ><template   v-for="(slideItem, slideIndex) in compData.exchangeInfo" :key="slideIndex" ><swiper-slide id="u_c_AKC7209"  v-if="!(slideIndex % compData.count) && !pageData.isEdit || pageData.isEdit && +slideIndex == 0" :class="[`normal`,`u_c_AKC7209`]" ><div id="u_c_68KA210"  v-for="(exchangeItem, eIndex) in compData.exchangeInfo" :key="eIndex" :class="[`normal`,`u_c_68KA210`]" ><div id="u_c_ICVZ211"  :data-index="exchangeItem.use" v-if="eIndex >= +slideIndex && eIndex < +slideIndex + +compData.count" :class="[`normal `,`u_c_ICVZ211`]" ><div id="u_c_D6QG212"  :class="[`normal btn-light`,`u_c_D6QG212`]" @click="u_c_D6QG212_event_00RH18($event,eIndex)"><div id="u_c_JHIL213"  :class="[`normal txt `,`u_c_JHIL213`]" >{{`${ langData.exchangeUse }`}}<div id="u_c_AH0Q215"  :class="[`normal txt`,`u_c_AH0Q215`]" >{{`${ exchangeItem.use }`}}</div></div><div id="u_c_HCIC217"  :style="`background-image:url(${ exchangeItem.pic })`" :class="[`normal`,`u_c_HCIC217`]" ></div><div id="u_c_E9QU218"  v-show="exchangeItem.state == 2 || exchangeItem.state == void 0 && eIndex == 0" :class="[`normal`,`u_c_E9QU218`]" ></div></div></div></div></swiper-slide></template></swiper></div><a id="u_c_OC45219" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`normal  btn-light  page-common-btn`,`u_c_OC45219`]" @click="u_c_OC45219_event_8J5W26($event)"><div id="u_c_DMAA220"  :class="[`normal page-common-btn`,`u_c_DMAA220`]" >{{`${ langData.getBtn }`}}</div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import { Swiper, SwiperSlide } from "swiper/vue";import { Navigation } from "swiper";import "swiper/css";import "swiper/css/navigation"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"exchangeInfo":[{"name":"兑换奖励1\n兑换奖励1-1","use":"5","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"兑换奖励2\n兑换奖励2-2","use":"10","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"兑换奖励3\n兑换奖励3-3","use":"15","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"20张券","use":"20","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"25张券","use":"25","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"30张券","use":"30","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"35张券","use":"35","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"40张券","use":"40","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"45张券","use":"45","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"50张券","use":"50","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"55张券","use":"55","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"60张券","use":"60","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"65张券","use":"65","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"70张券","use":"70","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"75张券","use":"75","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"80张券","use":"80","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"85张券","use":"85","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"90张券","use":"90","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"95张券","use":"95","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"},{"name":"100张券","use":"100","pic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709996794297.png"}],"subTitle":`活动期间，在【天使的选择】中累计消耗抽奖券进行抽奖，
达到一定次数后即可免费领取对应奖励（次数不会重置）`,"count":6,"title":`成神祝福赠礼`},"zh-TW":{"exchangeInfo":[{"name":"兵種技錦囊*10","use":"5","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"元寶*50\n點將令*5","use":"10","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"高級輜重箱*2\n急速行軍*5\n點將令*5","use":"15","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"元寶*200\n兵種技錦囊*10\n黄金沙漏*2","use":"20","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"高級輜重箱*2\n兵法集錄*10\n點將令*5","use":"30","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"洗煉隨機箱*50\n黃金沙漏*5\n兵種技錦囊*20","use":"40","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"元寶*588\n兵法集錄*10\n點將令*10","use":"50","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"拜將書*2\n洗煉隨機箱*50\n兵種技錦囊*20","use":"100","pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"高級輜重箱*20\n黄金沙漏*20\n拜將書*1","use":300,"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"元寶*788\n高級輜重箱*30\n英雄技錦囊*50","use":500,"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"羊脂玉*1\n洗煉隨機箱*200\n高級輜重箱*50","use":1000,"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"羊脂玉*2\n高級輜重箱*60\n拜將書*3","use":1500,"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"},{"name":"羊脂玉*4\n英雄技錦囊*100\n黄金沙漏*50","use":2000,"pic":"https://cdnimages.awselbcombine.com/public_images/one_image/2024/08/172250344831175630.png"}],"subTitle":`活動期間，累計消耗的抽獎券達到一定的數量，可以解鎖領取對應的獎勵；`,"count":6,"title":`二重好禮`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const initActivity = inject("initActivity", () => {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const listData = inject("listData", {})
const canClickRefresh = inject("canClickRefresh", true)
const giftInfo = inject("giftInfo", {})

const curPlatform = pagePlatform;

const init = () => {
  compData.exchangeInfo.forEach((item) => {
    item.state = 0
  })
}

watch(
  () => listData,
  (value) => {
    if (value && value.exchangeList) {
      let confList = _.cloneDeep(compData.exchangeInfo)
      compData.exchangeInfo = []
      value.exchangeList.forEach((item, index) => {
        if (confList[index]) {
          compData.exchangeInfo.push({
            pic: confList[index].pic,
            state: item.send_status,
            use: item.send_cost,
            id: item.id,
            name: confList[index].name,
          })
        }
      })
      giftInfo.exchangeAward = compData.exchangeInfo
    }
  }, {
    deep: true
  }
)

init()

const canClickExchange = ref(true)
const exchangeFn = async (id, index) => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'exchangeAward'), {
    params: JSON.stringify({
      id: id,
      language: curLang
    }),
  })
  if (res.result == 1) {
    compData.exchangeInfo[index].state = 2
    let curGiftName = res.data.send_type == 'sendSerial' ? res.data.send_value : compData.exchangeInfo[index].name;
    showGetSucc(res.data.send_type, compData.exchangeInfo[index].pic, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
};
      // 更新按钮的click事件
      const u_c_F4HT202_event_MAWI24= async (e)=>{
        try {if (!checkIsLogin()) return
        if (!checkIsBind()) return
        if(!canClickRefresh.value)return;
        canClickRefresh.value = false;
        initActivity();
        await utils.sleep(5);
        canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 自定义元素D6QG212的click事件
      const u_c_D6QG212_event_00RH18= async (e,index)=>{
        try {pageData.seeGift = [compData.exchangeInfo[index]]
pageData.seeGiftPopupState = true;} catch (error) {console.log(error)}
      };
      // 领取按钮的click事件
      const u_c_OC45219_event_8J5W26= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (!canClickExchange.value) return;
canClickExchange.value = false
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "领取兑换奖励",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
let curIndex = compData.exchangeInfo.findIndex(item => item.state == 1);
if (~curIndex) {
  await exchangeFn(compData.exchangeInfo[curIndex].id, curIndex);
} else {
  let finishIndex = compData.exchangeInfo.findIndex(item => item.state == 2);
  showTips(
    getLangTxt(
      finishIndex == compData.exchangeInfo.length - 1 ? '-10011' : '-10013',
      getLangTxt('common')
    ),
    ''
  );
}
canClickExchange.value = true;} catch (error) {console.log(error)}
      };const modules = computed(()=> [Navigation])
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_O87P194.normal{
position:relative;
width:10.00rem;
height:20.77rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307207835-76.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_O87P194.normal .txt{
color:#fffcf0;
font-size:0.29rem;

}
}.default{
.u_c_KU9E195.normal{
position:relative;
width:16.20rem;
height:1.60rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.53rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_KU9E195.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_H5DI196.normal{
position:relative;
margin-top:0.35rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#fafafa;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_EYZL197.normal{
position:relative;
text-align:center;
margin-top:0.24rem;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_BN8H198.normal{
position:relative;

}
}.default{
.u_c_M7UT200.normal{
position:relative;
margin:auto 0.13rem;

}
}.default{
.u_c_F4HT202.normal{
position:relative;
margin-left:2.67rem;

}
}.default{
.u_c_B0CK204.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.59rem;
text-align:center;

}
}.default{
.u_c_563O205.normal{
position:absolute;
width:0.76rem;
height:1.17rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497964-7.png);
background-size:contain;
top:105%;
z-index:2;
/*!rtl:ignore*/;
left:40%;

}
}.default{
.u_c_9TY9206.normal{
position:absolute;
width:0.76rem;
height:1.17rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497977-55.png);
background-size:contain;
top:105%;
z-index:2;
/*!rtl:ignore*/;
right:40%;

}
}.default{
.u_c_GCF1207.normal{
position:relative;

}
}.default{
.u_c_IZCM208.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_AKC7209.normal{
position:relative;
width:100%;

}
}.default{
.u_c_68KA210.normal{
position:relative;
display:inline-block;
font-size:0.27rem;

}
}.default{
.u_c_ICVZ211.normal{
position:relative;
margin:auto 0.13rem 0.40rem;
display:inline-block;

}
}.default{
.u_c_D6QG212.normal{
position:relative;
width:3.04rem;
height:3.28rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208260-2.png);
background-size:contain;
overflow:hidden;

}
}.default{
.u_c_JHIL213.normal{
position:relative;
margin-top:0.32rem;
font-size:0.29rem;
display:flex;
justify-content:center;
align-items:center;

}
}.default{
.u_c_AH0Q215.normal{
position:relative;
font-size:0.37rem;
font-weight:bold;
margin:auto 0.07rem;

}
}.default{
.u_c_HCIC217.normal{
position:relative;
width:2.53rem;
height:1.56rem;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:0.36rem;

}
}.default{
.u_c_E9QU218.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.default{
.u_c_OC45219.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.36rem;
height:2.77rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:1.80rem;

}
}.default{
.u_c_DMAA220.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.92rem;
font-weight:bold;

}
}.zh-TW{
.u_c_O87P194.normal{
position:relative;
width:10.00rem;
height:20.77rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307207835-76.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}

.u_c_O87P194.normal .txt{
color:#fffcf0;
font-size:0.29rem;

}
}.zh-TW{
.u_c_KU9E195.normal{
position:relative;
width:16.20rem;
height:1.60rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.53rem;
font-size:0.93rem;
color:#fedb2a;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_KU9E195.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_H5DI196.normal{
position:relative;
margin-top:0.35rem;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#fafafa;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_EYZL197.normal{
position:relative;
text-align:center;
margin-top:0.24rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_BN8H198.normal{
position:relative;

}
}.zh-TW{
.u_c_M7UT200.normal{
position:relative;
margin:auto 0.13rem;

}
}.zh-TW{
.u_c_F4HT202.normal{
position:relative;
margin-left:2.67rem;

}
}.zh-TW{
.u_c_B0CK204.normal{
position:relative;
width:10.00rem;
margin:auto;
margin-top:0.59rem;
text-align:center;

}
}.zh-TW{
.u_c_563O205.normal{
position:absolute;
width:0.76rem;
height:1.17rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497964-7.png);
background-size:contain;
top:105%;
z-index:2;
/*!rtl:ignore*/;
left:40%;

}
}.zh-TW{
.u_c_9TY9206.normal{
position:absolute;
width:0.76rem;
height:1.17rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497977-55.png);
background-size:contain;
top:105%;
z-index:2;
/*!rtl:ignore*/;
right:40%;

}
}.zh-TW{
.u_c_GCF1207.normal{
position:relative;

}
}.zh-TW{
.u_c_IZCM208.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_AKC7209.normal{
position:relative;
width:100%;

}
}.zh-TW{
.u_c_68KA210.normal{
position:relative;
display:inline-block;
font-size:0.27rem;

}
}.zh-TW{
.u_c_ICVZ211.normal{
position:relative;
margin:auto 0.13rem 0.40rem;
display:inline-block;

}
}.zh-TW{
.u_c_D6QG212.normal{
position:relative;
width:3.04rem;
height:3.28rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208260-2.png);
background-size:contain;
overflow:hidden;

}
}.zh-TW{
.u_c_JHIL213.normal{
position:relative;
margin-top:0.32rem;
font-size:0.29rem;
display:flex;
justify-content:center;
align-items:center;

}
}.zh-TW{
.u_c_AH0Q215.normal{
position:relative;
font-size:0.37rem;
font-weight:bold;
margin:auto 0.07rem;

}
}.zh-TW{
.u_c_HCIC217.normal{
position:relative;
width:2.53rem;
height:1.56rem;
margin:auto;
background:no-repeat center;
background-size:contain;
margin-top:0.36rem;

}
}.zh-TW{
.u_c_E9QU218.normal{
position:absolute;
width:1.03rem;
height:1.03rem;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16716174065561.png);
top:50%;
left:50%;
transform:translate(-50%,-50%);

}
}.zh-TW{
.u_c_OC45219.normal{
position:relative;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709850744352.png);
width:5.36rem;
height:2.77rem;
display:block;
margin:auto;
text-decoration:none;
overflow:hidden;
margin-top:1.80rem;

}
}.zh-TW{
.u_c_DMAA220.normal{
position:relative;
font-size:0.61rem;
color:white;
text-align:center;
margin-top:0.92rem;
font-weight:bold;

}
}
</style>
